import * as React from "react"
import { cn } from "@/lib/utils"

const TONE = { up: "text-status-paid", down: "text-status-overdue", neutral: "text-ink-subtle" }

function Metric({ label, value, delta, deltaTone = "neutral", className, ...props }) {
  return (
    <div className={cn("border-t border-line pt-3", className)} {...props}>
      <p className="text-micro uppercase text-ink-subtle">{label}</p>
      <p className="mt-2 font-sans text-metric tabular-nums text-ink">{value}</p>
      {delta && <p className={cn("mt-1 text-small tabular-nums", TONE[deltaTone])}>{delta}</p>}
    </div>
  )
}

export { Metric }
